module.exports = __webpack_public_path__ + "img/imgs6.3d51afac.png";